import React, { Component, Fragment } from 'react';
import { Button, Form, Header, Icon, Loader, Popup, Segment, Table } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import { toast, ToastContainer } from 'react-toastify';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';

class NonCycleProgramStudentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nonCycleStudents: [],
            externalStudents: [],
            loading: false,
            error: false,
            groupGraduating: false,
            groupGraduationDate: null,
            individualGraduationDates: {},
            saving: false,
        };
    }

    componentDidMount() {
        const program = this.props.program;
        if (!program) return;

        this.setState({ loading: true });
        Promise.all([
            axios.get('/non-cycle-student/non-cycle-program/' + program.id),
            axios.get('/external-student/non-cycle-program/' + program.id),
        ])
            .then(([nonCycleRes, externalRes]) => {
                const nonCycleStudents = nonCycleRes.data.filter(
                    s => s.nonCycleProgram && s.nonCycleProgram.id === program.id
                );

                const externalStudents = externalRes.data.filter(
                    s => s.nonCycleProgram && s.nonCycleProgram.id === program.id
                );

                this.setState({
                    nonCycleStudents,
                    externalStudents,
                    loading: false,
                    error: false
                });
            })
            .catch(() => {
                this.setState({
                    loading: false,
                    error: true
                });
            });
    }

    handleGroupGraduateClick = () => {
        const {
            nonCycleStudents,
            externalStudents
        } = this.state;
        const dates = {};
        nonCycleStudents.forEach(s => {
            dates['nc_' + s.id] = s.graduationDate ? new Date(s.graduationDate) : null;
        });
        externalStudents.forEach(s => {
            dates['ext_' + s.id] = s.graduationDate ? new Date(s.graduationDate) : null;
        });
        this.setState({
            groupGraduating: true,
            groupGraduationDate: null,
            individualGraduationDates: dates
        });
    };

    handleCancelGroupGraduate = () => {
        this.setState({
            groupGraduating: false,
            groupGraduationDate: null,
            individualGraduationDates: {},
            saving: false
        });
    };

    handleGroupDateChange = (date) => {
        const {
            nonCycleStudents,
            externalStudents
        } = this.state;
        const dates = {};
        nonCycleStudents.forEach(s => {
            dates['nc_' + s.id] = date;
        });
        externalStudents.forEach(s => {
            dates['ext_' + s.id] = date;
        });
        this.setState({
            groupGraduationDate: date,
            individualGraduationDates: dates
        });
    };

    handleIndividualDateChange = (key, date) => {
        this.setState(prev => ({
            individualGraduationDates: {
                ...prev.individualGraduationDates,
                [key]: date
            }
        }));
    };

    handleConfirmGroupGraduate = () => {
        const {
            nonCycleStudents,
            externalStudents,
            individualGraduationDates,
            groupGraduationDate
        } = this.state;
        this.setState({ saving: true });
        const ncPayload = nonCycleStudents.map(s => ({
            id: s.id,
            graduationDate: individualGraduationDates['nc_' + s.id]
        }));
        const extPayload = externalStudents.map(s => ({
            id: s.id,
            graduationDate: individualGraduationDates['ext_' + s.id]
        }));
        Promise.all([
            axios.put('/non-cycle-student/group-graduate', ncPayload),
            axios.put('/external-student/group-graduate', extPayload),
        ])
            .then(() => {
                toast(<FormattedMessage id="externalStudent.toast.groupGraduationSuccess"/>);
                this.handleCancelGroupGraduate();
                this.componentDidMount();
            })
            .catch(() => {
                toast(<FormattedMessage id="externalStudent.toast.saveError"/>);
                this.setState({ saving: false });
            });
    };

    render() {
        const {
            nonCycleStudents,
            externalStudents,
            loading,
            error,
            groupGraduating,
            groupGraduationDate,
            individualGraduationDates,
            saving,
        } = this.state;
        const program = this.props.program;

        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';
        const isProfessor = localStorageRole.slice(0, 8) === 'Profesor';
        const canGroupGraduate = isAdmin || isStudentService || isProfessor;

        const formatDate = (isoDate) => {
            if (!isoDate) return '-';
            const d = new Date(isoDate);
            return `${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()}.`;
        };

        const allStudents = [
            ...nonCycleStudents.map(s => ({
                ...s,
                _type: 'nc'
            })),
            ...externalStudents.map(s => ({
                ...s,
                _type: 'ext'
            })),
        ];

        return (
            <div>
                {loading ? (
                    <div style={{
                        paddingTop: '100px',
                        paddingBottom: '100px'
                    }}>
                        <Loader active inline="centered"/>
                    </div>
                ) : error ? (
                    <Segment textAlign="center">
                        <Button basic onClick={() => this.componentDidMount()}>
                            <FormattedMessage id="externalStudent.loadAgain"/>
                        </Button>
                    </Segment>
                ) : (
                    <Fragment>
                        {(!groupGraduating && (isStudentService || isProfessor)) &&
                            <Header style={IconHeader} floated={'right'}>
                                {canGroupGraduate && (
                                    <Button
                                        color="blue"
                                        icon
                                        labelPosition="right"
                                        size="small"
                                        onClick={this.handleGroupGraduateClick}
                                        disabled={groupGraduating || saving}
                                        style={FiltersOnStyle}
                                    >
                                        <Icon name="graduation cap"/>
                                        <FormattedMessage id="externalStudent.groupGraduating"/>
                                    </Button>
                                )}
                            </Header>}

                        {groupGraduating && (
                            <Segment secondary>
                                <Form>
                                    <Form.Group widths={'equal'}>
                                        <Form.Field>
                                            <FormattedMessage id="externalStudent.enterGraduationDate">
                                                {msg => (
                                                    <DateTimePicker
                                                        placeholder={msg}
                                                        format="D. M. YYYY."
                                                        time={false}
                                                        value={groupGraduationDate}
                                                        onChange={this.handleGroupDateChange}
                                                    />
                                                )}
                                            </FormattedMessage>
                                        </Form.Field>
                                        <Button color="blue" size="small" loading={saving} disabled={saving}
                                                onClick={this.handleConfirmGroupGraduate}>
                                            <FormattedMessage id="externalStudent.confirmGroupGraduation"/>
                                        </Button>
                                        <Button color="blue" basic size="small" disabled={saving}
                                                onClick={this.handleCancelGroupGraduate}>
                                            <FormattedMessage id="externalStudent.cancelGroupGraduation"/>
                                        </Button>
                                    </Form.Group>
                                </Form>
                            </Segment>
                        )}

                        <Table celled>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell width={1}>
                                        <FormattedMessage id="externalStudent.ordinalNumber"/>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <FormattedMessage id="externalStudent.fullName"/>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <FormattedMessage id="externalStudent.email"/>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <FormattedMessage id="externalStudent.graduationDate"/>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell width={1}/>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {allStudents.length > 0 ? allStudents.map((s, i) => {
                                    const key = s._type === 'nc' ? 'nc_' + s.id : 'ext_' + s.id;
                                    return (
                                        <Table.Row key={key}>
                                            <Table.Cell>{i + 1}.</Table.Cell>
                                            <Table.Cell>
                                                <div>{s.firstName} {s.lastName}</div>
                                                {s._type === 'ext' && (
                                                    <div style={{
                                                        fontSize: '0.85em',
                                                        color: '#999'
                                                    }}>
                                                        <FormattedMessage id="externalStudent.externalStudent"/>
                                                    </div>
                                                )}
                                            </Table.Cell>
                                            <Table.Cell>{s.email || '-'}</Table.Cell>
                                            <Table.Cell>
                                                {groupGraduating ? (
                                                    <FormattedMessage id="externalStudent.enterGraduationDate">
                                                        {msg => (
                                                            <DateTimePicker
                                                                placeholder={msg}
                                                                format="D. M. YYYY."
                                                                time={false}
                                                                value={individualGraduationDates[key] || null}
                                                                onChange={(date) => this.handleIndividualDateChange(key, date)}
                                                            />
                                                        )}
                                                    </FormattedMessage>
                                                ) : (
                                                    formatDate(s.graduationDate)
                                                )}
                                            </Table.Cell>
                                            <Table.Cell textAlign="center" verticalAlign="middle">
                                                <Popup
                                                    content={<FormattedMessage
                                                        id="externalStudent.studentProfile"/>}
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            as={Link}
                                                            to={{
                                                                pathname: s._type === 'nc'
                                                                    ? '/neciklicni-studij/student'
                                                                    : '/dolazne-mobilnosti/student',
                                                                state: { student: s }
                                                            }}
                                                            onClick={() => {
                                                                if (s._type === 'nc') {
                                                                    localStorage.setItem('nonCycleStudentId', s.id);
                                                                } else {
                                                                    localStorage.setItem('externalStudentId', s.id);
                                                                }
                                                            }}
                                                            size="small"
                                                            basic
                                                            circular
                                                            color="blue"
                                                            icon="user"
                                                            disabled={groupGraduating}
                                                        />
                                                    }
                                                />
                                            </Table.Cell>
                                        </Table.Row>
                                    );
                                }) : (
                                    <Table.Row>
                                        <Table.Cell colSpan={5} textAlign="left">
                                            <FormattedMessage id="common.noDataToDisplay"/>
                                        </Table.Cell>
                                    </Table.Row>
                                )}
                            </Table.Body>
                        </Table>
                    </Fragment>
                )}
                <ToastContainer position="top-right" hideProgressBar={true}/>
            </div>
        );
    }
}

export default NonCycleProgramStudentList;



// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleProgram/NonCycleProgramStudentList.js